import React, { useRef } from "react";
import { Row, Col, Icons, Button } from "cakemail-ui-components/lib/react";
import { Translate } from "react-redux-i18n";
import { connect } from "react-redux";
import { openBillingPortal } from "utils/apiUtils";
import PropTypes from "prop-types";
import {
	showStripeDowngradeDialog,
	showZendeskSupportDialog,
} from "assets/js/components/generalDialogs/simpleDialogs";

export const AccountUsage = (props) => {
	const planBtnRef = useRef(null);

	let contactLimit = "-";
	let emailsMonthlyLimits = "-";

	let contacts,
		emails,
		contactUsage,
		emailUsage = 0;

	if (props.account) {
		contactLimit = props.account.usage_limits.maximum_contacts;
		emailsMonthlyLimits = props.account.usage_limits.per_month;
	}

	if (props.usage) {
		contacts = props.usage.contacts;
		contactUsage = props.usage.contactUsage;
		emails = props.usage.emails;
		emailUsage = props.usage.emailUsage;
	}

	return (
		<div>
			<h6>
				<Row>
					<Col xs={6} className="contact-title">
						<Icons name="icon-usage" type="icon" />
						<b>
							<Translate value="app-menu-account-usage-title" />
						</b>
					</Col>
					<Col xs={6} className="account-detail">
						<p>
							<b>
								<Translate value="app-menu-list-account" />:{" "}
								{props?.account?.id}
							</b>
						</p>
					</Col>
				</Row>
			</h6>
			<Row>
				<Col xs={6} className="contact-title">
					<p>
						<Translate value="app-menu-account-usage-subscribers" />
					</p>
				</Col>
				<Col xs={6} className="contacts-count">
					<p>
						{contacts} / {contactLimit}
					</p>
				</Col>
			</Row>
			<Row className="contacts-bar">
				<Col xs={12}>
					<div className="contacts-progress">
						<div className="bar" style={{ width: contactUsage + "%" }}></div>
					</div>
				</Col>
			</Row>
			<Row>
				<Col xs={6} className="email-title">
					<p>
						<Translate value="app-menu-account-usage-email_sent" />
					</p>
				</Col>
				<Col xs={6} className="email-count">
					<p>
						{emails} / {emailsMonthlyLimits}
					</p>
				</Col>
			</Row>
			<Row className="contacts-bar">
				<Col xs={12}>
					<div className="contacts-progress">
						<div className="bar" style={{ width: emailUsage + "%" }}></div>
					</div>
				</Col>
			</Row>

			{props.stripeAccessPortal && (
				<Row className="upgrade-button">
					<Col xs={12}>
						<Button
							ref={planBtnRef}
							size="small"
							type="button"
							radius="square"
							shapeStyle="fill"
							colorTheme="teal"
							animated
							animatedOnClick
							text={
								<Translate value="app-menu-account-usage-manage_your_plan" />
							}
							onClick={() => {
								openBillingPortal(null, planBtnRef);
							}}
						/>

						<Button
							size="small"
							type="button"
							radius="square"
							shapeStyle="stroke"
							colorTheme="grey"
							text={
								<Translate value="app-menu-account-usage-manage_your_plan_downgrade" />
							}
							onClick={() => {
								showZendeskSupportDialog("downgrade");
							}}
						/>
					</Col>
				</Row>
			)}
		</div>
	);
};

AccountUsage.propTypes = {
	history: PropTypes.object,
	changeStatus: PropTypes.func,
	account: PropTypes.object,
	usage: PropTypes.object,
	stripeAccessPortal: PropTypes.bool,
};

export default connect((state) => {
	return {
		account: state.global.account,
		usage: state.global.usage,
		user: state.global.user,
		stripeAccessPortal: state?.brand?.config?.stripe_portal_access,
	};
})(AccountUsage);
